
//42
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "Popover4121224305",
    {"root":"Popover4121224305--root","popoverAnimation":"Popover4121224305--popoverAnimation","popoverAnimation-enter":"Popover4121224305--popoverAnimation-enter","popoverAnimation-enter-active":"Popover4121224305--popoverAnimation-enter-active","popoverAnimation-exit":"Popover4121224305--popoverAnimation-exit","popoverAnimation-exit-active":"Popover4121224305--popoverAnimation-exit-active","popoverContent":"Popover4121224305--popoverContent","arrow":"Popover4121224305--arrow","popover":"Popover4121224305--popover","withArrow":"Popover4121224305--withArrow","popoverElement":"Popover4121224305--popoverElement","contentBackgroundColor":"white","contentBorderWidth":"1px","contentBorderStyle":"solid","contentBorderColor":"black","contentBorderRadius":"initial","contentPadding":"initial","contentArrowSize":"5px"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/popover/Popover.st.css
// module id = 204
// module chunks = 0